import { evaluateSLAStatus } from '@chatwoot/utils';

// Wrapper do fork sobre o evaluateSLAStatus do @chatwoot/utils, corrigindo duas
// divergências que faziam cada tela contar um SLA diferente (2026-08-23,
// conv 160/conta 10 — ver .ai/painel-gestao-plan.md):
//
// 1. BASE: o util conta FRT/RT a partir do created_at do SLA APLICADO; o
//    backend (Sla::EvaluateAppliedSlaService, que grava as quebras e alimenta
//    relatórios e Painel de Gestão) conta a partir do created_at da CONVERSA.
//    Quando o SLA é aplicado depois da criação (nossa automação aplica na
//    entrada do time), o card prometia minutos que o backend já tinha
//    registrado como quebra. A base aqui é SEMPRE a da conversa.
// 2. NAMING: o util lê chat.first_reply_created_at/waiting_since em
//    snake_case; a inbox-view passa a conversa em camelCase → a 1ª resposta
//    ficava invisível e o card acusava "Quebra SLA FRT" falsa. Este wrapper
//    aceita os dois formatos.
const pick = (object, camel, snake) => {
  const value = object?.[camel];
  return value === undefined ? (object?.[snake] ?? null) : value;
};

export const evaluateSlaCardStatus = ({ conversation, appliedSla }) => {
  if (!conversation || !appliedSla) {
    return { type: '', threshold: '', icon: '', isSlaMissed: false };
  }

  const chat = {
    status: conversation.status,
    first_reply_created_at: pick(
      conversation,
      'firstReplyCreatedAt',
      'first_reply_created_at'
    ),
    waiting_since: pick(conversation, 'waitingSince', 'waiting_since'),
  };

  const sla = {
    id: pick(appliedSla, 'id', 'id'),
    sla_first_response_time_threshold: pick(
      appliedSla,
      'slaFirstResponseTimeThreshold',
      'sla_first_response_time_threshold'
    ),
    sla_next_response_time_threshold: pick(
      appliedSla,
      'slaNextResponseTimeThreshold',
      'sla_next_response_time_threshold'
    ),
    sla_resolution_time_threshold: pick(
      appliedSla,
      'slaResolutionTimeThreshold',
      'sla_resolution_time_threshold'
    ),
    created_at:
      pick(conversation, 'createdAt', 'created_at') ??
      pick(appliedSla, 'createdAt', 'created_at'),
  };

  return evaluateSLAStatus({ appliedSla: sla, chat });
};
